import React from "react";

interface CheckboxesProps {
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: (selected: string[]) => void;
}

const Checkboxes: React.FC<CheckboxesProps> = ({
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  const handleChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };
  return (
    <div className="flex flex-col gap-2">
      {options.map((option) => (
        <label
          key={option}
          className="flex items-start cursor-pointer border p-3 rounded-md bg-white text-gray-800 transition-colors duration-150 border-electrum-150 hover:border-electrum-250 has-[:checked]:bg-electrum-100 has-[:checked]:border-electrum-250"
        >
          <input
            type="checkbox"
            checked={selectedOptions.includes(option)}
            onChange={() => handleChange(option)}
            className="w-6 h-6 cursor-pointer border bg-electrum-100 rounded-md appearance-none transition-colors duration-150 checked:bg-electrum-400 checked:border-electrum-400 flex-shrink-0 bg-center bg-no-repeat bg-[length:16px]"
            style={{
              backgroundImage: selectedOptions.includes(option)
                ? "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E\")"
                : "none",
            }}
          />
          <span
            className="ml-3 text-base flex-1 min-w-0 leading-6"
            style={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {option}
          </span>
        </label>
      ))}
    </div>
  );
};

export default Checkboxes;
